import { render } from "./AccountAgreement.vue?vue&type=template&id=3c6a4bfa&scoped=true"
import script from "./AccountAgreement.vue?vue&type=script&lang=js"
export * from "./AccountAgreement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3c6a4bfa"

export default script